export default __webpack_public_path__ + "static/wydzia-psychologii-w-sopocie_logo_vector_horizontal_bt-3dc4cbe99159897c3287db56b9d456a9.svg";